import { memo, PropsWithChildren } from 'react';
import { EmergencyLogo, LogoIP } from '../common/Logos';

import './LoadingSpinner.css';

export default memo(function LoadingSpinner(props: PropsWithChildren<LogoIP>) {

    return (<div className={props.className || `mx-auto text-center py-5`}>
        <EmergencyLogo
            className='logo'
            maxHeight={props.maxHeight}
            minHeight={props.minHeight}
            minWidth={props.minWidth} />
    </div>);
})